module.exports = __webpack_public_path__ + "static/hawley-hex-d964fd8a79e335ffc791e5d68d9c902a.png";